import React, { useMemo, useState, useEffect } from "react";

import { useLazyQuery } from "@apollo/client";

import SideBar from "../../../Components/Sidebar/SideBar";
import { GET_ASSETS } from "../_redux/graphQl/query";

export default function CategoryAssets(id, props) {
  const [assetsList, setAssetsList] = useState([]);

  const [userDetail, setUserDetail] = useState(null);

  const categoryId = id;

  useMemo(() => {
    const user = JSON.parse(window.localStorage.getItem("user"));

    setUserDetail(user);
  }, []);

  const [
    getAssets,
    { loading: assetsLoading, error: assetsError, data: assetsData },
  ] = useLazyQuery(GET_ASSETS, {
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (assetsData) {
      const data = assetsData.listCategoriesByPriority;

      if (data && Array.isArray(data)) {
        setAssetsList(data);
      }
    }
  }, [assetsData, assetsError, assetsLoading]);

  useEffect(() => {
    listAssets();
  }, [getAssets]);

  const listAssets = () => {
    getAssets({
      variables: { categoryId: categoryId },
    });
  };

  return (
    <>
      <SideBar>
        <div
          style={{
            display: "block",
            width: "100%",
            height: 45,
            marginTop: "-500px",
          }}
        >
          <div>Assets List</div>
        </div>
      </SideBar>
    </>
  );
}
